<mat-menu id="menu-main-nav-lnk-dropdown"
	class="vtr-material-hamburger-menu min-height-0 hamburger-menu-container"
	#hamburgerMenuMain="matMenu"
	xPosition="before"
	yPosition="below"
	backdropClass="hamburger-backdrop">
	<nav class="hambuger-menu">
		<ul class="left-padding-0">
			<ng-container *ngFor="let item of items">
				<li *ngIf="item && !item.hide && (!item.subitems || item.subitems.length === 0) && item.id !== 'user'"
					class="d-block">
					<button mat-menu-item
						*ngIf="item.label | translate"
						class="m-0 px-3 w-100 text-left color-light border-radius-0 min-width-0 outline-none font-size-sm menu-item {{item.id}} menu-item-color"
						id="menu-main-nav-lnk-{{item.id}}"
						attr.new-tip-id="new-tip-{{item.id}}"
						routerLink="/{{item.path}}"
						routerLinkActive="active"
						href="javascript:void(0)"
						(click)="onMenuItemClick(item)"
						(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown(item.path)]">
						<span class="menu-item-text">
							{{item.label | translate}}
						</span>
					</button>
				</li>
				<li *ngIf="item && !item.hide && item.subitems && item.subitems.length > 0 && item.id !== 'user'"
					class="d-block">
					<button mat-menu-item
						*ngIf="item.label | translate"
						id="menu-main-nav-lnk-dropdown-toggle-{{item.id}}"
						class="m-0 px-3 w-100 text-left color-light border-radius-0 min-width-0 outline-none font-size-sm menu-item {{item.id}} menu-item-color"
						[ngClass]="{'actived': updateActiveItem(item.id)}"
						attr.aria-label="{{item.id}}"
						attr.new-tip-id="new-tip-{{item.id}}"

						routerLink="/{{item.path}}"
						routerLinkActive="active"
						href="javascript:void(0)"
						(click)="onMenuItemClick(item)"
						(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown(item.path)]">
						<span class="menu-item-text" [innerHTML]="item.label | translate"></span>
					</button>
					<ng-container *ngFor="let subitem of item.subitems; let i=index" class="ml-5">
						<button mat-menu-item
							*ngIf="subitem && !subitem.hide && subitem.externallink"
							id="menu-main-nav-lnk-dropdown-menu-external-{{item.id}}-{{i}}"
							class="pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
							attr.aria-label="{{subitem.label | translate }}"
							routerLinkActive="active"
							[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
							[ngClass]="{'font-weight-bold text-uppercase': hasSecondaryMenu(item), 'disable': hasSecondaryMenu(item)}"
							target="_blank"
							rel="noopener"
							href="javascript:void(0)"
							(click)="openExternalLink(subitem.path)"
							[disabled]="hasSecondaryMenu(item)">
							<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="subitem.label | translate"></span>
						</button>
						<button mat-menu-item
							*ngIf="subitem && !subitem.hide && !subitem.externallink && !subitem.singleLayerRouting"
							id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{i}}"
							class="pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
							attr.aria-label="{{subitem.label| translate}}"
							routerLinkActive="active"
							[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
							[ngClass]="{'font-weight-bold text-uppercase': hasSecondaryMenu(item), 'disable': hasSecondaryMenu(item)}"
							routerLink="/{{item.path}}/{{subitem.path}}"
							href="javascript:void(0)"
							(click)="onMenuItemClick(item)"
							(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown(item.path, subitem.path)]"
							[disabled]="hasSecondaryMenu(item)">
							<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="subitem.label | translate"></span>
						</button>
						<button mat-menu-item
							*ngIf="subitem && !subitem.hide && !subitem.externallink && subitem.singleLayerRouting"
							id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{i}}"
							class="pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
							attr.aria-label="{{subitem.label| translate}}"
							routerLinkActive="active"
							[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
							[ngClass]="{'font-weight-bold text-uppercase': hasSecondaryMenu(item), 'disable': hasSecondaryMenu(item)}"
							routerLink="/{{subitem.path}}"
							href="javascript:void(0)"
							(click)="onMenuItemClick(item)"
							(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown(subitem.path)]"
							[disabled]="hasSecondaryMenu(item)">
							<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="subitem.label | translate"></span>
						</button>
						<section *ngIf="subitem && !subitem.hide && hasSecondaryMenu(item)">
							<ng-container *ngFor="let secondarySubitem of subitem.subitems; let ii=index">
								<button mat-menu-item
									*ngIf="secondarySubitem && !secondarySubitem.hide && secondarySubitem.externallink"
									id="menu-main-nav-lnk-dropdown-menu-external-{{item.id}}-{{subitem.id}}-{{ii}}"
									class="d-inline-block pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
									attr.aria-label="{{secondarySubitem.label | translate }}"
									routerLinkActive="active"
									[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
									target="_blank"
									rel="noopener"
									href="javascript:void(0)"
									(click)="[onMenuItemClick(item), openExternalLink(secondarySubitem.path)]">
									<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="secondarySubitem.label | translate"></span>
								</button>

								<button mat-menu-item
									*ngIf="secondarySubitem && !secondarySubitem.outletLink && !secondarySubitem.hide && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
									id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{subitem.id}}-{{ii}}"
									class="d-inline-block pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
									attr.aria-label="{{secondarySubitem.label| translate}}"
									routerLinkActive="active"
									[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
									[routerLink]="secondarySubitem.path"
									href="javascript:void(0)"
									role="menuitem"
									(click)="onMenuItemClick(secondarySubitem)"
									(keydown.enter)="onMenuItemClick(secondarySubitem)">
									<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="secondarySubitem.label | translate"></span>
								</button>
								<button mat-menu-item
									*ngIf="secondarySubitem && secondarySubitem.outletLink && !secondarySubitem.hide && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
									id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{subitem.id}}-{{ii}}"
									class="d-inline-block pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
									attr.aria-label="{{secondarySubitem.label| translate}}"
									routerLinkActive="active"
									[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
									[routerLink]="secondarySubitem.outletLink"
									href="javascript:void(0)"
									role="menuitem"
									(click)="onMenuItemClick(secondarySubitem)"
									(keydown.enter)="onMenuItemClick(secondarySubitem)">
									<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="secondarySubitem.label | translate"></span>
								</button>
								<button mat-menu-item
									*ngIf="secondarySubitem && !secondarySubitem.hide && !secondarySubitem.externallink && secondarySubitem.singleLayerRouting"
									id="menu-main-nav-lnk-dropdown-menu-{{item.id}}-{{subitem.id}}-{{ii}}"
									class="d-inline-block pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
									attr.aria-label="{{secondarySubitem.label| translate}}"
									routerLinkActive="active"
									[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
									routerLink="/{{secondarySubitem.path}}"
									href="javascript:void(0)"
									role="menuitem"
									(click)="onMenuItemClick(item)"
									(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown(secondarySubitem.path)]">
									<span class="d-block overflow-hidden w-auto menu-item-text" [innerHTML]="secondarySubitem.label | translate"></span>
								</button>
							</ng-container>
						</section>
					</ng-container>
				</li>
				<li *ngIf="item && !item.hide && item.id === 'user' && languageService.isLanguageLoaded"
					class="d-block">
					<hr>

					<button mat-menu-item
						id="menu-main-lnk-open-preference"
						class="pl-5 py-2 border-radius-0 font-size-xs outline-none menu-item menu-item-color h-auto menu-subitem"
						attr.aria-label="menu-main-lnk-open-preference"
						href="javascript:void(0)"
						routerLink="settings"
						routerLinkActive="active"
						(click)="onMenuItemClick(item)"
						(keydown.enter)="[onMenuItemClick(item), menuItemKeyDown('settings')]">
						<span class="d-block overflow-hidden w-auto menu-item-text"
							[innerHTML]="'settings.preferenceSettings' | translate">
						</span>
					</button>
				</li>
			</ng-container>
		</ul>
	</nav>
</mat-menu>
